<template>
  <v-row align="center" justify="center">
    <v-col cols="12" sm="8" md="4" class="zh-card">
      <v-card class="elevation-12" :max-width="500">
        <v-toolbar color="primary" dark flat>
          <v-toolbar-title>問卷調查系統</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-btn color="primary" block @click="doLogin('10')">企業會員登入</v-btn>
          <v-btn color="primary" class="mt-3" block @click="doLogin('20')">
            一般會員登入
          </v-btn>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    this.initApp();
    return {
      BlizLoginUrl: {
        // '10': 'https://biz.ipickup.com.tw/SSO?UserName=ZhTech_bk&ReturnUrl_Token=',
        // '20': 'https://www.bizlion.com.tw/BizLion/SignIn/Login?username=ZhTech&userToken_returnUrl='
        // '10': 'https://demo.ipickup.com.tw/SSO?UserName=ZhTech_bk&ReturnUrl_Token=',
        // '20': 'https://demo.ipickup.com.tw/BizLion/SignIn/Login?username=ZhTech&userToken_returnUrl='
        '10': '/SSO?UserName=ZhTech_bk&ReturnUrl_Token=',
        '20': '/BizLion/SignIn/Login?username=ZhTech&userToken_returnUrl='
      }
    }
  },
  methods: {
    initApp() {
    let url = this.$store.state.api + '/Q01005/loginServer'
    let res
    window.console.log(url)
    this.axios.post(url).then((res)=> { 
      window.console.log(res) 
      if(this.$store.state.loginServerEnterprise == null)
      this.$store.state.loginServerEnterprise = res.data.loginServer_enterprise
      if(this.$store.state.loginServer == null)
      this.$store.state.loginServer = res.data.loginServer 
    window.console.log(this.$store.state.loginServerEnterprise)    
    window.console.log(this.$store.state.loginServer)    
      }) 
    },
    doLogin(type) {
      // type 10 企業會員 20 一般會員
      // 取得當前網址()，作為 SSO 登入後的 userToken_returnUrl 參數
      let returnHref = window.location.href
      let arr = returnHref.split('/')
      arr.pop() // 去除 Login
      returnHref = arr.join('/')
      returnHref += '?clientUserType=' + type

      // 把 userToken 存入 store，並指定給變數 userToken
      let userToken = (this.$store.state.user.userToken = this.$route.query.UserToken)
      let needBlizLogin = !userToken || userToken.length === 0
      // 導向商業獅 SSO 登入頁面
      if(type == "10")
      this.BlizLoginUrl[type] = this.$store.state.loginServerEnterprise + this.BlizLoginUrl[type]
      else
      this.BlizLoginUrl[type] = this.$store.state.loginServer + this.BlizLoginUrl[type]
      if (needBlizLogin) window.location.href = this.BlizLoginUrl[type] + returnHref
    }
  }
}
</script>

<style lang="scss" scoped>
.zh-card {
  opacity: 0.75;
}
</style>
